export const validateConfig = {

  isRequired: (fieldName) => [
    {
      required: true,
      message: `Please select ${fieldName}`,
    },
    {
      validator: (_, value) => {
        if (typeof value === "string" && value.length > 0 && !value.trim()) {
          return Promise.reject(new Error(`Please select ${fieldName}`));
        }
        return Promise.resolve();
      },
    },
  ],
};
